var $9e8abf676819580b$exports = {};
$9e8abf676819580b$exports = {
    "backButton": (args)=>`Vissza ide: ${args.prevMenuButton}`,
    "moreActions": `Tov\xe1bbi lehet\u{151}s\xe9gek`,
    "unavailable": `Nem \xe9rhet\u{151} el, a r\xe9szletek\xe9rt bontsa ki`
};


export {$9e8abf676819580b$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
